(() => {
  document.querySelectorAll('[data-collection-product]').forEach((module) => {
    const idInput = module.querySelector('[data-variant-id]');
    const stock = module.querySelector('[data-product-stock]');
    const price = module.querySelector('[data-product-price]');
    const submit = module.querySelector('[data-add-to-cart]');
    const cardForChoice = (choice) => choice?.closest('.collection-highlight__bundle')
      || (choice?.id ? module.querySelector(`label[for="${choice.id}"]`) : null);
    const choiceForModeCard = (card) => card.querySelector('[data-variant-choice]')
      || (card.htmlFor ? module.querySelector(`#${card.htmlFor}`) : null);

    module.querySelectorAll('[data-variant-choice]').forEach((choice) => {
      choice.addEventListener('change', () => {
        if (!choice.checked) return;
        idInput.value = choice.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        module.querySelectorAll('.collection-highlight__bundle').forEach((card) => card.classList.remove('is-selected'));
        cardForChoice(choice)?.classList.add('is-selected');
        const available = choice.dataset.available === 'true';
        stock.lastChild.textContent = available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('is-unavailable', !available);
        price.innerHTML = `${choice.dataset.comparePrice ? `<s>${choice.dataset.comparePrice}</s>` : ''}<strong>${choice.dataset.price}</strong>${choice.dataset.comparePrice ? '<span>Sale</span>' : ''}`;
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      });
    });

    const coupleToggle = module.querySelector('[data-couple-toggle]');
    if (coupleToggle) {
      const updateCoupleMode = () => {
        const visibleChoices = [];
        module.querySelectorAll('[data-couple-variant]').forEach((card) => {
          card.hidden = (card.dataset.coupleVariant === 'true') !== coupleToggle.checked;
          if (!card.hidden) visibleChoices.push(choiceForModeCard(card));
        });
        const currentChoice = module.querySelector('[data-variant-choice]:checked');
        const currentModeCard = currentChoice?.closest('[data-couple-variant]') || cardForChoice(currentChoice);
        if (!currentChoice || currentModeCard?.hidden) {
          const nextChoice = visibleChoices.find((choice) => choice && !choice.disabled);
          if (nextChoice) {
            nextChoice.checked = true;
            nextChoice.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
      coupleToggle.addEventListener('change', updateCoupleMode);
      updateCoupleMode();
    }

    const coupleModeButtons = module.querySelectorAll('[data-couple-mode]');
    if (coupleModeButtons.length) {
      const updateCardMode = (mode) => {
        const visibleChoices = [];
        coupleModeButtons.forEach((button) => {
          const active = button.dataset.coupleMode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        module.querySelectorAll('[data-couple-variant]').forEach((card) => {
          const cardMode = card.dataset.coupleVariant === 'true' ? 'couple' : 'single';
          card.hidden = cardMode !== mode;
          if (!card.hidden) visibleChoices.push(choiceForModeCard(card));
        });
        const currentChoice = module.querySelector('[data-variant-choice]:checked');
        const currentModeCard = currentChoice?.closest('[data-couple-variant]') || cardForChoice(currentChoice);
        if (!currentChoice || currentModeCard?.hidden) {
          const nextChoice = visibleChoices.find((choice) => choice && !choice.disabled);
          if (nextChoice) {
            nextChoice.checked = true;
            nextChoice.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
      coupleModeButtons.forEach((button) => button.addEventListener('click', () => {
        updateCardMode(button.dataset.coupleMode);
        const hint = module.querySelector('[data-bundle-hint]');
        if (hint) hint.innerHTML = button.dataset.coupleMode === 'couple'
          ? '<strong>Couples pack selected.</strong> Two kits, packed together for convenience.'
          : '<strong>Testing with a partner?</strong> Switch to a couples pack and save.';
      }));
      updateCardMode('single');
    }

    const quantity = module.querySelector('input[name="quantity"]');
    module.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    module.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
  });

})();
